import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.promise.finally";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.object.assign";
import React, { useState, useCallback, useEffect } from 'react';
import Calendar, { Skeleton } from 'react-activity-calendar';
export { createCalendarTheme } from 'react-activity-calendar';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function fetchCalendarData(_x, _x2) {
  return _fetchCalendarData.apply(this, arguments);
}

function _fetchCalendarData() {
  _fetchCalendarData = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(username, year) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(API_URL).concat(username, "?y=").concat(year));

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            data = _context.sent;

            if (response.ok) {
              _context.next = 8;
              break;
            }

            throw new Error(data.error);

          case 8:
            return _context.abrupt("return", data);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCalendarData.apply(this, arguments);
}

var GitHubCalendar = function GitHubCalendar(_ref) {
  var username = _ref.username,
      _ref$year = _ref.year,
      year = _ref$year === void 0 ? 'last' : _ref$year,
      props = _objectWithoutProperties(_ref, ["username", "year"]);

  var _props$theme;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var fetchData = useCallback(function () {
    setLoading(true);
    setError(null);
    fetchCalendarData(username, year).then(function (_ref2) {
      var contributions = _ref2.contributions;
      return setData(contributions);
    })["catch"](setError)["finally"](function () {
      return setLoading(false);
    });
  }, [username, year]);
  useEffect(fetchData, []); // on mount

  useEffect(fetchData, [username, year]);

  if (error) {
    return (
      /*#__PURE__*/
      React.createElement("div", null,
      /*#__PURE__*/
      React.createElement("i", null, "Unable to fetch contribution data. See console."))
    );
  }

  if (loading || !data) {
    return (
      /*#__PURE__*/
      React.createElement(Skeleton, {
        loading: true
      })
    );
  }

  var theme = props.color ? undefined : (_props$theme = props.theme) !== null && _props$theme !== void 0 ? _props$theme : DEFAULT_THEME;
  var labels = {
    totalCount: "{{count}} contributions in ".concat(year === 'last' ? 'the last year' : '{{year}}')
  };
  return (
    /*#__PURE__*/
    React.createElement(Calendar, _extends({
      data: data,
      theme: theme,
      labels: labels
    }, props))
  );
}; // GitHub theme


var DEFAULT_THEME = {
  level4: '#216e39',
  level3: '#30a14e',
  level2: '#40c463',
  level1: '#9be9a8',
  level0: '#ebedf0'
};
var API_URL = 'https://github-contributions-api.jogruber.de/v4/';
export { GitHubCalendar as default };